var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.308 21.75q-.748 0-1.278-.53a1.74 1.74 0 0 1-.53-1.278v-9.384q0-.748.53-1.278t1.278-.53H7.5v-2q0-1.873 1.313-3.186Q10.128 2.25 12 2.25t3.187 1.314Q16.5 4.876 16.5 6.75v2h1.192q.749 0 1.278.53.53.53.53 1.278v9.384q0 .749-.53 1.278-.53.53-1.278.53zm0-1.5h11.384a.3.3 0 0 0 .221-.087.3.3 0 0 0 .087-.22v-9.385a.3.3 0 0 0-.087-.222.3.3 0 0 0-.22-.086H6.307a.3.3 0 0 0-.221.086.3.3 0 0 0-.087.222v9.384a.3.3 0 0 0 .087.221.3.3 0 0 0 .22.087M12 17q.729 0 1.24-.51.51-.511.51-1.24t-.51-1.24T12 13.5t-1.24.51q-.51.511-.51 1.24t.51 1.24T12 17M9 8.75h6v-2q0-1.25-.875-2.125A2.9 2.9 0 0 0 12 3.75q-1.25 0-2.125.875A2.9 2.9 0 0 0 9 6.75z"
  })));
};
export default SvgLock;